import { map } from "lodash";
import moment from "moment";
import {
  IOrder,
  IOrderGroup,
  IOrderGroupItem,
  IOrderItem,
} from "../interfaces/order";
import { IProduct, ProductTag } from "../interfaces/product";
import Config from "./Config";

export function Currency(
  value: number,
  hasDecimal = false,
  hasSymbol = true,
  decimalPlace: number = 2
) {
  if (!value) {
    value = 0;
  }

  // https://www.wikitechy.com/tutorials/javascript/print-a-number-with-commas-as-thousands-separators-in-javascript
  function thousands_separators(num: string) {
    var num_parts = hasDecimal ? parseFloat(num).toFixed(2).split(".") : num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // use decimal?
    if (hasDecimal) return num_parts.join(".");
    return num_parts[0];
  }
  return `${hasSymbol ? Config.currencySymbol + " " : ""}${thousands_separators(
    value.toString()
  )}`;
}

export function MakeReference(length: number) {
  var result = "";
  // var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var characters = "ABCDEFGHJKPQRSTUWYZ123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function DateFormatter(val: number) {
  if (!val) {
    return "";
  }
  return moment.unix(val).format("MMM D, YYYY");
}

export function GetPricetag(product: IProduct) {
  if (product?.sellers) {
    let arr = [];
    for (var i in product.sellers) {
      if (product.sellers[i].status === "active") {
        arr.push(product.sellers[i]);
      }
    }
    if (arr.length) {
      return {
        mpu: arr[0].mpu,
        price: arr[0].price,
      };
    }
    return null;
  }
  return null;
}

export function GetProductMeta(product: IProduct) {
  let raw_meta = product?.sellers[Object.keys(product?.sellers)[0]]?.meta;
  if (raw_meta) {
    return SafeJSONObject(raw_meta);
  }
  return null;
}

export function GetProductStockCount(product: IProduct) {
  let quantity = product?.sellers[Object.keys(product?.sellers)[0]]?.quantity;
  if (quantity > 0) {
    return quantity;
  }
  return null;
}

export function GetLowerUpperUnitText(product: IProduct, quantity: number) {
  const cases = Math.round(quantity / product?.case_count);
  const units = quantity % product?.case_count;

  return (
    (cases > 0
      ? `${cases} ${product?.tags?.[ProductTag.HigherUnit]?.value}${
          cases > 1 ? "s" : ""
        }${units ? " " : ""}`
      : ``) +
    (units > 0
      ? `${units} ${product?.tags?.[ProductTag.LowerUnit]?.value}${
          units > 1 ? "s" : ""
        }`
      : ``)
  );
}

export function GetProductInCart(cartState: any, product_id: string) {
  let inCart = cartState?.order_group_items?.find(
    (x: IOrderGroupItem) => x.product_id === product_id
  );
  if (inCart) {
    return inCart;
  }
  return null;
}

export function GetOrderGroupOrderItems(order_group: IOrderGroup) {
  let _list: any[] = [];

  try {
    order_group.orders.list.map((order_list: any) => {
      order_list.order_items.map((order_list_item: IOrderGroupItem) => {
        if (order_list?.tag === "completed") _list.push(order_list_item);
      });
    });

    _list = _list.filter((item) => {
      item.product.pricetag = GetPricetag(item?.product);
      return item;
    });
  } catch (e) {
    console.log(e);
  }

  return _list;
}

export function SafeJSONObject(jsonString: any) {
  if (!(jsonString && typeof jsonString === "string")) {
    return {};
  }

  try {
    let value = JSON.parse(jsonString);
    return value;
  } catch (error) {
    return {};
  }
}

export function SafeJSONArray(jsonString: any) {
  if (!(jsonString && typeof jsonString === "string")) {
    return [];
  }

  try {
    let value = JSON.parse(jsonString);
    return value;
  } catch (error) {
    return [];
  }
}
